export default __webpack_public_path__ + "static/media/guest_form.9337cce4.svg";